import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

/**
 * Shared chrome for the two public legal pages. No login, no app shell —
 * Twilio's toll-free reviewer opens these straight from the opt-in page, and
 * so do employees on a phone.
 */
export function LegalLayout({
  title,
  updated,
  children,
}: {
  title: string;
  updated: string;
  children: ReactNode;
}) {
  return (
    <div data-industrial className="ui-ind-paint min-h-screen bg-graphite-950 px-4 py-8 text-graphite-100">
      <div className="mx-auto max-w-2xl">
        <p className="mb-1 text-center text-[11px] font-bold uppercase tracking-[0.2em] text-red-500">NADC · DemoOps</p>
        <h1 className="text-center text-2xl font-bold">{title}</h1>
        <p className="mt-1 text-center text-sm text-graphite-500">
          North American Dismantling Corp. · Last updated {updated}
        </p>

        <div className="mt-6 space-y-5 rounded-xl border border-graphite-700 bg-graphite-900 p-5 text-sm leading-relaxed text-graphite-300">
          {children}
        </div>

        <p className="mt-6 text-center text-xs text-graphite-500">
          <Link to="/sms-opt-in" className="underline hover:text-graphite-400">Text message sign-up</Link>
          {' · '}
          <Link to="/terms" className="underline hover:text-graphite-400">Terms of Service</Link>
          {' · '}
          <Link to="/privacy" className="underline hover:text-graphite-400">Privacy Policy</Link>
        </p>
      </div>
    </div>
  );
}

export function Section({ heading, children }: { heading: string; children: ReactNode }) {
  return (
    <section>
      <h2 className="mb-1.5 text-base font-semibold text-graphite-100">{heading}</h2>
      <div className="space-y-2">{children}</div>
    </section>
  );
}
